// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"752bff67","442":"04a3643d"}[chunkId] + ".chunk.js";
};